module.exports = __webpack_public_path__ + "static/media/filled_end_bar.8b6e3f49.svg";